import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { LinkData } from '../../../interfaces'
@Component({
  selector: 'dmmp-item-menu',
  templateUrl: './item-menu.component.html'
})
export class ItemMenuComponent implements OnInit {

  @Input() menuItem
  @Input() menuLevel
  @Output() actionEmitter = new EventEmitter()
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  @Output() externalLink = new EventEmitter()
  linkData: LinkData

  constructor() { }

  ngOnInit(): void {
    this.linkData = {
      link: [
        {
          link: this.menuItem?.data?.link,
          name: this.menuItem?.data?.name
        }
      ],
      target: this.menuItem?.data?.target
    }
  }

}
